import type { QueryKey } from '@tanstack/react-query';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { RetryQueryAlert } from '@/components/alerts/retry-query-alert';
import { RedirectToLogin } from '@/components/redirect-to-login';
import { NotFoundPage } from '@/pages/errors/not-found-page';

export type ProductionDeclarationErrorFallbackProps = {
  error: unknown;
  queryKey: QueryKey;
  loadErrorMessage: string;
  resetErrorBoundary: () => void;
};

export function ProductionDeclarationErrorFallback({
  error,
  queryKey,
  loadErrorMessage,
  resetErrorBoundary,
}: ProductionDeclarationErrorFallbackProps) {
  const { t } = useTranslation('productionDeclaration', {
    useSuspense: false,
  });
  const status = axios.isAxiosError(error) ? error.response?.status : undefined;

  const message =
    status === 403 ? t('tokenInvalidOrExpired') : loadErrorMessage;

  if (status === 401) {
    return <RedirectToLogin />;
  }
  if (status === 404) {
    return <NotFoundPage />;
  }

  return (
    <RetryQueryAlert
      message={message}
      onRetry={resetErrorBoundary}
      queryKey={queryKey}
    />
  );
}
